<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('BatteryFile.batteryNumber')">
                    <el-input
                      size="mini"
                      v-model="formInline.batteryNumber"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.carId')">
                    <el-input
                      size="mini"
                      v-model="formInline.carId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.terminalId')">
                    <el-input
                      size="mini"
                      v-model="formInline.terminalId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('BATTERYFILE_BIND')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="bindBattery"
                  >{{ $t("common.btn.bind") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('BATTERYFILE_TRANSFER')"
                  type="text"
                  :disabled="selected.length == 0"
                  @click="transferBattery"
                  >{{ $t("common.btn.transfer") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('BATTERYFILE_EDIT')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="editBattery"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('BATTERYFILE_DELETE')"
                  type="text"
                  :disabled="selected.length == 0"
                  @click="deleteBattery"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('BATTERYFILE_ADD')"
                  type="text"
                  @click="addBattery"
                  >{{ $t("common.btn.add") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('BATTERYFILE_BATCHIMPORT')"
                  type="text"
                  @click="BulkImport"
                  >{{ $t("common.btn.batchUpload") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('BATTERYFILE_DOWN')"
                  type="text"
                  @click="downBattery"
                  >{{ $t("common.btn.download") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="650px"
        :before-close="closeDia"
        class="batteryDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="batteryNumber"
            :label="$t('BatteryFile.batteryNumber') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              :disabled="disabled"
              v-model="form.batteryNumber"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="carId"
            :label="$t('common.carId') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              :disabled="disabled"
              v-model="form.carId"
              autocomplete="off"
            ></el-input>
            <el-button v-if="disabled" @click="Relieve()">{{
              $t("common.btn.unBind")
            }}</el-button>
          </el-form-item>
          <el-form-item
            prop="terminalId"
            :label="$t('common.terminalId') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              :disabled="isDisabled"
              v-model="form.terminalId"
              autocomplete="off"
            ></el-input>
            <el-button v-if="isDisabled" @click="isRelieve()">{{
              $t("common.btn.unBind")
            }}</el-button>
          </el-form-item>
          <el-form-item
            prop="batteryType"
            :label="$t('BatteryFile.batteryType') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="form.batteryType"
              :placeholder="$t('BatteryFile.form.batteryType')"
              filterable
            >
              <el-option
                :label="$t('BatteryFile.plumbicAcid')"
                value="1"
              ></el-option>
              <el-option
                :label="$t('BatteryFile.lithium')"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="power"
            :label="$t('BatteryFile.power') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.power"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="capacity"
            :label="$t('BatteryFile.capacity') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.capacity"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="ratedChargingSpeed"
            :label="$t('BatteryFile.ratedChargingSpeed') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.ratedChargingSpeed"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="ratedDischargeSpeed"
            :label="$t('BatteryFile.ratedChargingSpeed') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.ratedDischargeSpeed"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeTransferDia"
        class="transferDialong"
        :title="$t('BatteryFile.transferDialong')"
        :visible.sync="dialogTransferFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :rules="TransferRules"
          ref="TransferForm"
          :model="TransferForm"
        >
          <el-form-item
            prop="batteryNumber"
            :label="$t('BatteryFile.batteryNumber') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              disabled
              type="textarea"
              :rows="2"
              size="small"
              v-model="TransferForm.batteryNumber"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="roleId"
            :label="$t('BatteryFile.roleId') + ':'"
            :label-width="LabelWidth"
          >
            <el-scrollbar>
              <tree :isSearch="isSearch" @nodeClick="changeClick"></tree>
            </el-scrollbar>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleTransfer('TransferForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitTransferForm('TransferForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeBindDia"
        class="addDialong"
        :title="$t('BatteryFile.addDialong')"
        :visible.sync="dialogBindFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="BindRules" ref="BindForm" :model="BindForm">
          <el-form-item
            prop="batteryNumber"
            :label="$t('BatteryFile.batteryNumber') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              size="small"
              disabled
              v-model="BindForm.batteryNumber"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="carId"
            :label="$t('common.carId') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              size="small"
              v-model="BindForm.carId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="terminalId"
            :label="$t('common.terminalId') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              size="small"
              v-model="BindForm.terminalId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleBind('BindForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitBindForm('BindForm')"
            >{{ $t("common.btn.bind") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeBatchDia"
        :title="$t('common.btn.batchUpload')"
        :visible.sync="dialogBatchFormVisible"
        class="batchDialong"
        :close-on-click-modal="false"
      >
        <div class="right-file">
          <el-button type="text" size="mini" @click="TemplateFile()">{{
            $t("common.btn.downloadModelFile")
          }}</el-button>
        </div>
        <div class="upload-file">
          <img src="../../../assets/images/upload.png" />
          <div>{{ $t("common.btn.clickUploadFile") }}</div>
          <input @change="uploadBattery()" id="uploadDom" type="file" style="display: none;" />
          <el-button type="primary" size="small" @click="triggerFileUpload()">{{ $t("common.btn.uploadFile") }}</el-button>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogBatchFormVisible = false" class="btn-del">{{
            $t("common.btn.cancel")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import BatteryFile from "./BatteryFile.js";
export default BatteryFile;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
